/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import may from 'js/security';
import { ROLE_ADMIN } from 'js/constants';
import { deleteSubscriptionR, deactivateSubscriptionR } from 'actions/SubscriptionsActions';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import List from 'components/List';
import FormSwitchery from 'components/forms/FormSwitchery';
import { getDeviceType } from 'cc-editor/components/actions/deviceType';
import { confirmAlert } from 'react-confirm-alert';
import { addSubscriptionPriceForUserR, editSubscriptionPriceForUserR } from 'actions/SubscriptionPricesActions';
import Breadcrumb from '../Breadcrumb';
import SimplePrompt from '../SimplePrompt';
import Loader from '../Loader';
import SubscriptionNew from './SubscriptionNew';
import SubscriptionEdit from './SubscriptionEdit';
import IntlDateTime from '../IntlDateTime';

class Subscriptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      showEdit: false,
      subscriptionId: '',
    };
  }

  // componentDidMount = () => {
  //   const { getSubscriptionsR } = this.props;
  //   getSubscriptionsR();
  // };

  openAddSubscription = () => {
    this.setState({ showNew: true });
  };

  closeAddSubscription = () => {
    this.setState({ showNew: false });
  };

  openEditSubscription = subscriptionId => {
    this.setState({ subscriptionId }, () => {
      this.setState({ showEdit: true });
    });
  };

  deleteSubscription = id => {
    const { deleteSubscriptionR } = this.props;
    deleteSubscriptionR(id);
  };

  closeEditSubscription = () => {
    this.setState({ showEdit: false });
  };

  translateSubscription = index => {
    const {
      subscriptions,
      appIntl: { locale },
    } = this.props;

    const {
      data: { list },
    } = subscriptions;

    const {
      subscription: { description },
    } = list[index];

    const matchingDescription = description.find(({ lang }) => lang === locale);

    return matchingDescription?.description; // or name
  };

  deactivateSubscription = idToDeactivate => {
    const {
      subscriptions,
      deactivateSubscriptionR,
      intl: { messages },
    } = this.props;
    const {
      data: { list },
    } = subscriptions;
    const subscription = list.find(({ id }) => id === idToDeactivate);
    subscription.is_active = !subscription.is_active;
    deactivateSubscriptionR(idToDeactivate, subscription ?? null, messages);
  };

  getBreadcrumb = () => {
    const {
      appIntl: { urlPrefix },
      intl: { messages },
    } = this.props;

    const crumbs = [
      { link: urlPrefix + 'account', name: 'Dashboard' },
      { link: urlPrefix + 'account/settings', name: messages.settings },
      { link: null, name: messages.subscriptions_ },
    ];

    return <Breadcrumb crumbs={crumbs} className="p-t-0" />;
  };

  render() {
    const {
      intl: { messages },
      subscriptions,
      user,
      roles,
    } = this.props;
    const { showNew, showEdit, subscriptionId } = this.state;

    const {
      data: { list },
      pending,
    } = subscriptions;

    const columns = [
      messages.subscription_name,
      messages.subscription_description,
      messages.subscription_fee,
      messages.subscription_startingFee,
      messages.subscription_start,
      messages.subscription_end,
      messages.subscription_billing_period,
      messages.subscription_status,
      messages.subscription_action,
    ];

    const tBody = list.map(subscription => {
      const { id, name, fee, starting_fee, period_start, period_end, is_active, billing_cycle } = subscription;
      return (
        <tr key={id} className="clickable" onClick={() => {}}>
          <td class="v-align-middle">
            <span>{name}</span>
          </td>
          <td className="v-align-middle">
            <span>&hellip;</span>
          </td>
          <td className="v-align-middle">
            <span>{fee}</span>
          </td>
          <td className="v-align-middle">
            <span>{starting_fee}</span>
          </td>
          <td className="v-align-middle">
            <span> {period_start && <IntlDateTime date={period_start} />}</span>
          </td>
          <td className="v-align-middle">
            <span> {period_end && <IntlDateTime date={period_end} />}</span>
          </td>
          <td className="v-align-middle">
            <span>{messages[billing_cycle]}</span>
          </td>
          <td className="v-align-middle subscriptionStatus">
            <FormSwitchery
              name="status"
              label=""
              value
              checked={!!is_active}
              onChange={() => {
                this.deactivateSubscription(id);
              }}
              disabled=""
            />
          </td>
          <td class="v-align-middle text-right">
            {may(ROLE_ADMIN, user.roles) && (
              <>
                <SimplePrompt className="m-l-5 m-t-5 m-b-5" onSuccess={() => this.deleteSubscription(id)} />
                <Button
                  onClick={() => this.openEditSubscription(id)}
                  bsStyle="warning"
                  className="pull-right m-l-5 m-t-5 m-b-5"
                  title="create_subscription"
                >
                  <i className="far fa-edit" />
                  <span className="hidden-xs"> {messages.subscription_edit}</span>
                </Button>
              </>
            )}
          </td>
        </tr>
      );
    });

    return (
      <>
        <List noRender listName="roles" url="/api/roles.json" list={roles} />
        <div className="padding-25 sm-padding-10">
          <List
            listName="subscriptions"
            url="/api/subscriptions/list/subscriptions.json"
            // urlData={urlData}
            list={subscriptions}
            title={messages.subscriptions_}
            iconClass="fad fa-repeat-alt"
            showNew
            newText={messages.add_subscription}
            newAction={this.openAddSubscription}
            showSearch={false}
            // sortOptions={['relevance,desc', 'cdate,desc', 'mdate,desc', 'priority,desc']}
            breadcrumb={this.getBreadcrumb()}
            metaIdentifier="Subscriptions:Subscription"
            // displayTypes={['list', 'columns']}
            // activeDisplayType={displayType}
            // changeDisplayType={this.changeDisplayType}
            // filters={filters}
          >
            {pending ? (
              <Loader />
            ) : (
              <Table responsive hover>
                <thead>
                  <tr>
                    {columns.map(column => {
                      return (
                        <th key={column} className={column === messages.actions ? 'text-right' : ''}>
                          {column}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="tablerows"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={1}
                  component="tbody"
                >
                  {tBody}
                </ReactCSSTransitionGroup>
              </Table>
            )}
          </List>
        </div>
        <div id="subscription-new">
          <SubscriptionNew
            show={showNew}
            close={this.closeAddSubscription}
            closeAddSubscription={this.closeAddSubscription}
            roles={roles}
          />
        </div>

        <div id="subscription-edit">
          <SubscriptionEdit
            show={showEdit}
            close={this.closeEditSubscription}
            closeEditSubscription={this.closeEditSubscription}
            subscriptionId={subscriptionId}
            roles={roles}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    subscriptions: state.list.subscriptions,
    roles: state.list.roles,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteSubscriptionR: id => {
      dispatch(deleteSubscriptionR(id));
    },
    deactivateSubscriptionR: (id, data, messages) => {
      dispatch(deactivateSubscriptionR(id, data, messages));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Subscriptions)
  )
);
